<template>
  <v-bottom-navigation
    v-if="isMobileMode"
    id="bottom-nav"
    :value="activePath"
    app
    fixed
    grow
    dark
    color="primary"
    background-color="#333333"
    height="58"
  >
    <v-btn
      v-for="item in items"
      :key="item.to"
      :value="item.to"
      text
      class="bnav-btn"
      @click="onSelect(item)"
    >
      <span class="bnav-label">{{ item.title }}</span>
      <v-icon small>{{ item.icon }}</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
import menuItems from "./menuItems";

export default {
  name: "BottomNav",
  data() {
    return {
      isMobileMode: false,
      // The bottom bar carries the regular menu plus a dedicated Home entry.
      items: [{ title: "Home", icon: "mdi-home", to: "/account/home" }, ...menuItems],
    };
  },
  computed: {
    activePath() {
      return this.$route.path;
    },
  },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  methods: {
    onResize() {
      this.isMobileMode = window.innerWidth < 990;
    },
    onSelect(item) {
      this.$store.commit("SET_ACTIVE_CLASS", item.title);
      if (item.to !== this.$route.path) {
        this.$router.push(item.to).catch(() => {});
      }
    },
  },
};
</script>

<style scoped>
#bottom-nav {
  z-index: 5;
}

#bottom-nav .bnav-btn {
  min-width: 0;
  padding: 0 2px;
}

#bottom-nav .bnav-label {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 9px;
  line-height: 1.1;
  letter-spacing: 0;
  text-transform: none;
}

#bottom-nav .v-icon {
  margin-bottom: 0;
}
</style>
